
import React from "react";
import SafeHtml from "components/shared/helpers/SafeHtml";
import {
  Button,
  Card,
  Details,
  FlexColumn,
  SushiModal,
  VerticalLine,
  WhiteWrapper,
  Wrapper,
} from "../../Common/styles.common";
import { Circle } from "../styles.po";
import { Loader } from "../../Common/Loader";
import moment from "moment";
import { strings } from "utils/constants/strings";
import DDPoHeader from "../../Header/DDPoHeader";
import DownloadIcon from "sushiweb/Icons/all/Download";
import Input from "components/shared/InputTypes/Input";

const DDPoDetailsMobile = ({
  po,
  grn,
  items,
  showLoader,
  tonnage,
  popupText,
  showPopup,
  showInvoiceNumberModal,
  setShowInvoiceNumberModal,
  overriddenInvoiceNumber,
  navigateToInvoiceForm,
  navigateToBuyerOrdersList,
  handleGenerateEwb,
  togglePopupModel,
  downloadDeliveryInvoices,
  clickInsertInvoiceNumber,
  generateInvoiceCTA,
  handleInvoiceNumberChange,
  shouldShowEwbButton,
  navigate,
  purchaseOrderId,
  getActionBarCTA,
}) => {
  return (
    <React.Fragment>
      {showLoader ? (
        <Loader />
      ) : (
        <Wrapper>
          {showInvoiceNumberModal && (
            <SushiModal
              visible={showInvoiceNumberModal}
              isCentered
              title={"Enter Invoice Number"}
              showCloseIcon={true}
              onClose={() => setShowInvoiceNumberModal(false)}
            >
              <FlexColumn className="align-items-center invoice-modal w-full">
                <span className="wd-100">
                  <Input
                    type="text"
                    placeholder="Invoice number"
                    value={overriddenInvoiceNumber}
                    onChange={(value) => handleInvoiceNumberChange(value)}
                    className="w-full  border-redius-12   input-class"
                  />
                  {" "}
                </span>
                <Button
                  className="fs-13 text-white fw-600 border-redius-12"
                  onClick={generateInvoiceCTA}
                >
                  Click to Generate Invoice
                </Button>
              </FlexColumn>
            </SushiModal>
          )}
          <DDPoHeader
            poId={po.id}
            purchaseOrderNumber={po.purchase_order_number}
            itemsLength={items.length}
            tonnage={tonnage}
            source="details"
            orderTag={po.order_tag}
          ></DDPoHeader>
          <div className="d-flex flex-column po-content">
            <Details>
              <div className="d-flex flex-column mx-4">
                <div className="d-flex align-items-center">
                  <Circle>
                    <img
                      src="/logos/rupee_logo.svg"
                      height="16px"
                      width="15px"
                    />
                  </Circle>
                  <span className="fs-14 text-gray-cool ml-3">&#8377;</span>
                  {po && (
                    <span className="fs-14 fw-400 text-gray-cool">
                      {po.po_amount?.toLocaleString("en-IN")} {strings.poAmount}
                    </span>
                  )}
                </div>
                <div className="d-flex align-items-center mt-3">
                  <Circle>
                    <img
                      src="/logos/delivery_logo.svg"
                      height="16px"
                      width="15px"
                    />
                  </Circle>
                  {po.expected_delivery_date ? (
                    <span className="fs-14 fw-400 text-gray-cool ml-3">
                      Delivery by{" "}
                      {moment(new Date(po.expected_delivery_date))
                        .format("DD MMM, YYYY")
                        .toString()}
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
                {po.order_tag === "DIRECT_DELIVERY" && po.buyer_outlet_details?.name?.length > 0 ? (
                  <div className="d-flex align-items-center mt-3">
                    <Circle>
                      <img
                        src="/logos/location_logo.svg"
                        height="16px"
                        width="15px"
                      />
                    </Circle>
                    <span className="fs-14 fw-400 text-gray-cool ml-3 wd-po-card">
                      {po.buyer_outlet_details?.name}
                    </span>
                  </div>
                ) : (null)}
                <div className="d-flex align-items-center mt-3">
                  <Circle onClick={() => downloadDeliveryInvoices()}>
                    <DownloadIcon />
                  </Circle>
                  <span className="fs-14 fw-400 text-red-500 ml-3 wd-po-card">
                    Download delivery documents
                  </span>
                </div>
                {shouldShowEwbButton() && (
                  <div className="d-flex mt-4" style={{ gap: '12px' }}>
                    <Button
                      className="fs-14 text-white fw-400"
                      onClick={handleGenerateEwb}
                      style={{ borderRadius: "12px", height: "auto", minHeight: "38px", padding: '8px 4px', flex: 1 }}
                    >
                      Generate E-Way bill
                    </Button>
                    <Button
                      className="fs-14 text-white fw-400"
                      onClick={() => navigate(`/ddPo/uploadDocs/${purchaseOrderId}`)}
                      style={{ borderRadius: "12px", height: "auto", minHeight: "38px", padding: '8px 4px', flex: 1 }}
                    >
                      Upload delivery documents
                    </Button>
                  </div>
                )}
              </div>
            </Details>
            <span className="fs-20 fw-700 ml-4 mt-5">{strings.productDetails}</span>
            <div className="mx-4 my-4">
              {items != "" ? (
                items.map((item, index) => (
                  <div key={index}>
                    <Card className="mb-4">
                      <div className="d-flex mx-4">
                        <img
                          src={item?.product_image}
                          height="48px"
                          width="48px"
                          style={{ borderRadius: "8px" }}
                        />
                        <div className="d-flex flex-column justify-content-center ml-4">
                          <span className="fs-16 fw-600 mb-1">
                            {item?.product_name}
                          </span>
                          <span className="fs-15 fw-400 text-gray-cool">
                            &#8377; {item?.price_per_unit}/{item?.buy_measurement_unit}
                          </span>
                        </div>
                      </div>

                      <Card hideShadow={true} className="align-items-center mx-4 mt-3">
                        <div className="d-flex wd-100 justify-content-center">
                          <div className="d-flex flex-column wd-50 align-items-center">
                            <span className="fs-15 fw-700">
                              {item?.quantity_ordered} {item?.buy_measurement_unit}
                            </span>
                            <span className="fs-13 fw-400 text-gray-cool mt-2">
                              {strings.orderQty}
                            </span>
                          </div>
                          <VerticalLine />
                          <div className="d-flex flex-column wd-50 align-items-center">
                            <span className="fs-15 fw-700">
                              &#8377;{(item?.quantity_ordered * item?.price_per_unit)?.toLocaleString("en-IN")}
                            </span>
                            <span className="fs-13 fw-400 text-gray-cool mt-2">
                              {strings.orderAmount}
                            </span>
                          </div>
                        </div>
                      </Card>

                    </Card>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
          <WhiteWrapper className="po-bottom">
            {(() => {
              const cta = getActionBarCTA?.();
              if (!cta) return null;
              return (
                <Button className="fs-13 text-white fw-600" onClick={cta.onClick}>
                  {cta.label}
                </Button>
              );
            })()}
          </WhiteWrapper>
          <SushiModal visible={showPopup} isCentered>
            <FlexColumn className="align-items-center p-5">
              <img src={"/logos/info_logo.svg"} height="80px" width="80px" />
              <span className="fs-22 fw-700 my-4">{popupText}</span>
              <span
                className="fs-14 fw-500 text-red-500"
                onClick={togglePopupModel}
              >
                {" "}
                Okay
              </span>
            </FlexColumn>
          </SushiModal>
        </Wrapper>
      )}
    </React.Fragment>
  );
};

export default DDPoDetailsMobile;
